import styled from 'styled-components'

import { outlineNegativeStyles } from 'components/Editor/styled/Outline'
import type { BrandType } from 'services/Branding/types'

const StyledCourseMenuItem = styled.li<{
  $hovered: boolean
  $selected: boolean
  $disabled: boolean
  $isFocused: boolean
  $theme: BrandType['theme']
}>`
  display: flex;
  align-items: center;
  padding: 0 12px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  color: ${({ $selected, $theme }) => ($selected ? $theme.primaryColor : $theme.primaryTextColor)};
  border-radius: 4px;
  line-height: 32px;
  white-space: nowrap;
  background-color: ${({ $theme }) => $theme.primaryBackgroundColor};

  &:hover {
    background-color: ${({ $disabled, $theme }) => ($disabled ? 'transparent' : $theme.hoverColor)};
  }

  ${({ $isFocused }) => $isFocused && outlineNegativeStyles}
`

export default StyledCourseMenuItem
